import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'canteen_eating_areas_are_not_protected_from_elements'

export const dataPointDefinition = {
  retracedId: 'canteen_eating_areas_are_not_protected_from_elements',
  name: 'Canteen / eating areas are not protected from the elements and/or have no adequate seating, tables and lighting',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-can-5x',
      number: 'HS-CAN-3-2',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-can-3',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],fp-bs-7,Yes. Eating area only.;Yes. Canteen only.;Yes. Canteen and eating area.',
      machineShowHide: '[2],fp-bs-7,1;2;3',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-can-5x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30000,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
